module.exports = __webpack_public_path__ + "fonts/iconfont.4dc664e6.eot";